module.exports = __webpack_public_path__ + "static/media/Capture.514eb1fb.jpeg";